import {Model} from 'vue-mc';
import * as dateMethods from "@/helpers/date-methods";

export class MonitorCorreosModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      estatus : ""
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      estatus:estatus=>estatus
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}


// WEBPACK FOOTER //
// ./src/models/bitacoras/monitor-correos.js